import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import {
  chart_title_reducer,
  ModalReducer,
  KeycloakReducer,
  toastrReducer,
  sales_reducer,
  branch_category_reducer,
  package_reducer,
  crdm_reducer,
  unredeemed_reducer,
  customer_profiling_reducer,
  previous_month_average_reducer,
  inventory_target_reducer,
  daily_summary_reducer,
  profit_breakdown_reducer,
} from "./reducers";

const allReducers = combineReducers({
  modal: ModalReducer,
  keycloak: KeycloakReducer,
  toastr: toastrReducer,
  package: package_reducer,
  sales: sales_reducer,
  branch_category: branch_category_reducer,
  crdm: crdm_reducer,
  daily_summary: daily_summary_reducer,
  unredeemed_pawns: unredeemed_reducer,
  customer_profile: customer_profiling_reducer,
  previous_month_average: previous_month_average_reducer,
  inventory_target: inventory_target_reducer,
  profit_breakdown: profit_breakdown_reducer,
  chart_title: chart_title_reducer,
});

let middleware = [thunk];

let composeEnhancer = compose;

if (process.env.REACT_APP_NAME === "LOCAL") {
  if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const allStoreEnchancers = composeEnhancer(applyMiddleware(...middleware));

const store = createStore(allReducers, allStoreEnchancers);

export default store;